import Tooltip from 'rlink-tooltips/Tooltip';
import themeable from 'rlink-theme/themeable';
import {createElement, PropTypes} from 'rlink-react';
import {mergeStaticOptions} from 'rlink-utils/object';

import InputBase from './InputBase';

export default class CheckboxInput extends InputBase {
  get inputType () {
    return 'checkbox';
  }

  get checkedValue () {
    return this.fromPropsOrContext('checkedValue');
  }

  get uncheckedValue () {
    return this.fromPropsOrContext('uncheckedValue');
  }

  isChecked (value) {
    return value === this.checkedValue;
  }


  handleChange (ev) {
    let value = ev.target.checked ? this.checkedValue : this.uncheckedValue;

    this.fireCommitValue(ev, value);
    return super.handleChange({
      event: ev,
      value,
    });
  }

  hasValue (value) {
    return this.isChecked(value);
  }


  renderInput () {
    return <input type={this.inputType}
      id={this.labelId}
      ref={input => {
        this.inputRef = input;
      }}
      disabled={this.disabled}
      name={this.name}
      onFocus={ev => this.handleFocus(ev)}
      onBlur={ev => this.handleBlur(ev)}
      onChange={ev => this.handleChange(ev)}
      value={this.checkedValue}
      checked={this.isChecked(this.value)} />;
  }

  render () {
    return (<Tooltip content={this.props.tooltip}>
      <div className={`control ${this.className}`}>
        <label htmlFor={this.labelId}>
          {this.renderInput()}
          <span className="renderedCheckbox" />
          {this.renderLabel()}
          {this.renderHelp()}
          {this.renderError()}
        </label>
      </div>
    </Tooltip>);
  }
}


mergeStaticOptions(CheckboxInput, {
  propTypes: {
    checkedValue: PropTypes.any,
    uncheckedValue: PropTypes.any,
  },
  defaultProps: {
    checkedValue: true,
    uncheckedValue: false,
  },
});

themeable(CheckboxInput, {
  classes: [
    'Label',
    'InputCheckbox',
  ],
});



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/CheckboxInput.jsx